module.exports = __webpack_public_path__ + "static/media/img-opponent.0130deb8.png";